import { CountdownItem } from "./CountdownItem";
import { LaborHourItem } from "./LaborHourItem";
import { LaborJobTrackingItem } from "./LaborJobTrackingItem";
import { LaborJobTrackingTotals } from "./LaborJobTrackingTotals";
import { ManualTipShare } from "./ManualTipShares";
import { OrderTypeSummaries } from "./OrderTypeSummaries";
import { OutOfStockItem } from "./OutOfStockItem";
import { PaymentTotal } from "./PaymentTotal";
import { ProjectedOvertime } from "./ProjectedOvertime";
import { ReportGroupSummaries } from "./ReportGroupSummaries";
import { Store } from "./Store";
import { TrackingItem } from "./TrackingItems";

export class SalesSummary {
	venueKey: number = 0;
	CheckDate: string;
	businessDate: string;
	NetSales: number = 0;
	LaborCost: number = 0;
	LaborPercentage: number = 0;
	VoidCount: number = 0;
	VoidAmount: number = 0;
	DiscountCount: number = 0;
	DiscountAmount: number = 0;
	RefundCount: string;
	RefundAmount: number = 0;
	ReturnItemCount: number = 0;
	ReturnItemAmount: number = 0;
	DepositCount: number = 0;
	DepositAmount: number = 0;
	GiftCardCount: number = 0;
	GiftCardAmount: number = 0;
	PaidoutCount: number = 0;
	PaidoutAmount: number = 0;
	TipFee: number = 0;
	AdvanceAmount: number = 0;
	NetCash: number = 0;
	SafeReportPriorDaySafeCount: number = 0;
	SafeReportBankDeposits: number = 0;
	SafeReportChangeOrders: number = 0;
	SafeReportBalanceDue: number = 0;
	SafeReportSafeCount: number = 0;
	SafeReportPettyCashUnloaded: number = 0;
	SafeReportDrawerTillsAdd: number = 0;
	SafeReportCashCountTotal: number = 0;
	SafeReportOverShort: number = 0;
	FirstClockInTime: string;
	FirstClockInName: string;
	FirstCheckOfDayTime: string;
	CheckCount: number = 0;
	AverageCheck: number = 0;
	GuestCount: number = 0;
	AverageGuest: number = 0;
	AverageTime: string;
	OpenCheckCount: number = 0;
	ReopenedCheckCount: number = 0;
	MissingBeverageCount: number = 0;
	//MealPeriod1: string;
	MealPeriod1Sales: number = 0;
	//MealPeriod2: string;
	MealPeriod2Sales: number = 0;
	//MealPeriod3: string;
	MealPeriod3Sales: number = 0;
	//MealPeriod4: string;
	MealPeriod4Sales: number = 0;
	OutOfStockItemsCount: number = 0;
	CountdownItemsCount: number = 0;
	TrackingItemsCount: number = 0;
	VariablePriceItemsCount: number = 0;
	VariablePriceItemsSales: number = 0;
	turnTimeInSeconds: number = 0;

	PaymentTotal: PaymentTotal[];

	TrackingItems: TrackingItem[];

	CountdownItem: CountdownItem[];

	OutOfStockItem: OutOfStockItem[];

	LaborJobTrackingTotals: LaborJobTrackingTotals[];

	LaborHourItems: LaborHourItem[];

	LaborJobTrackingItems: LaborJobTrackingItem[];

	ProjectedOvertime: ProjectedOvertime[];

	OrderTypeSummaries: OrderTypeSummaries[];

	ReportGroupSummaries: ReportGroupSummaries[];

	TipShare: ManualTipShare[];

	stores: Store;

	public constructor(init?: Partial<SalesSummary>) {
		Object.assign(this, init);
	}
}
